import StorePopup from './store-popup';
import ScreenLock from "../__constants/lock-screen";

const $ = jQuery.noConflict();

class StickyCart {
    constructor() {
        this.toggleBtn = '.js-toggle-cart';
        this.stickyCart = '.sticky-cart';
        this.stickyCartOverlay = '.sticky-cart-overlay';
    }

    init() {
        this.events();
        this.formatPrice();
    }

    events() {
        $(document).on('click', this.toggleBtn, () => {
            $(this.stickyCart).toggleClass('active');
            $(this.stickyCartOverlay).toggleClass('active');

            if ($(this.stickyCart).hasClass('active')) {
                ScreenLock.lock();
            } else {
                ScreenLock.unlock();
            }
        });

        $(document).on('click', '.sticky-cart__product-qty .minus', (event) => {
            const btn = $(event.currentTarget);
            const value = parseInt(btn.next().val());
            if (value !== 0) {
                btn.next().val(value - 1).change();
            }
        });

        $(document).on('click', '.sticky-cart__product-qty .plus', (event) => {
            const btn = $(event.currentTarget);
            const value = parseInt(btn.prev().val());
            btn.prev().val(value + 1).change();
        });

        $(document).on('change', '.sticky-cart__product-qty input[type="number"]', event => {
            const input = event.currentTarget;
            const value = parseInt($(input).val());
            this.formatPrice();
            this.changeCartQuantity(value, $(input).attr('data-product-id'));
        });
    }

    formatPrice() {
        const priceEl = $('.sticky-cart__product-price span:nth-child(2)');

        priceEl.each((index, el) => {
            const defaultPrice = $(el).attr('data-price');
            const qty = $(el).closest('.sticky-cart__product-meta').find('input[type="number"]').val();
            $(el).text(`$${StorePopup.twoDecimalPlaces(defaultPrice * qty)} AUD`);
        });
    }

    changeCartQuantity(qty, productID) {
        const data = {
            action: 'woocommerce_ajax_change_qty',
            variation_id: parseInt(productID),
            quantity: parseInt(qty),
        };

        $.ajax({
            type: 'post',
            url: WP.ajaxUrl,
            data,
            beforeSend: () => {
                $('.sticky-cart__products').addClass('loading');
            },
            complete: () => {
                $('.sticky-cart__products').removeClass('loading');
            },
            success: (response) => {
                $(this.stickyCart).html(response);
            },
        });
    }
}

export default new StickyCart();
